import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from 'src/environments/environment';

import { Observable, of } from "rxjs";

import { ICancelPayload, ICreditCardDetails, ISubmitPayment } from "../../interfaces";
import { ISendLinkPayload, ISendLinkResponse } from 'src/app/shared/components/link-transfer/link-transfer.interface';

import { ICardOnFile } from 'src/app/shared/components/card-on-file/card-on-file.interface';

@Injectable({
  providedIn: 'root'
})

export class CreditCardService {

  paymentBasePath = `${environment.apiBasePath}commonPayment/`;

  constructor( private http: HttpClient ) { }

  getCreditCardDetailsNew(refId: string): Observable<ICreditCardDetails | null> {
    if (!refId) return of(null);
    return this.http.get<ICreditCardDetails | null>(`${this.paymentBasePath}getByReferenceId/${refId}?uniqId=${Math.floor(Math.random() * 1000) + 1}`);
  }

  getCardOnFileDetails(contractNumber:string): Observable<ICardOnFile[] | false | null> {
    if (!contractNumber) {
      console.log('No Contract Number to fetch card on file data'); return of(false);
    }

    return this.http.get<ICardOnFile[] | false | null>(`${this.paymentBasePath}cards-on-file?contractId=${Math.trunc(Number(contractNumber))}`);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  submitPayment(payload: any): Observable<any> {
    let requestUrl = 'updatePaymentDetails';

    if (payload.paymentActionType) {
      requestUrl = (payload.paymentActionType != 'Customer Initiated') ? 'payment-info/' + payload.paymentActionType : 'payment-info';
    }

    return this.http.post<ISubmitPayment>(`${this.paymentBasePath}${requestUrl}`, payload);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cancelPayment(payload: ICancelPayload): Observable<any> {
    return this.http.put(`${this.paymentBasePath}cancelPayment`, payload);
  }

  captureBySMS(clickCount: number, payload: ISendLinkPayload): Observable<ISendLinkResponse> {
    if (clickCount > 1) {
      return this.captureBySMSThroughSalesforce(payload);
    }

    return this.captureBySMSThroughTwillio(payload);
  }

  captureBySMSThroughTwillio(payload: ISendLinkPayload): Observable<ISendLinkResponse> {
    return this.http.post<ISendLinkResponse>(`${this.paymentBasePath}sms/capture-link`, payload);
  }

  captureBySMSThroughSalesforce(payload: ISendLinkPayload): Observable<ISendLinkResponse> {
    return this.http.post<ISendLinkResponse>(`${this.paymentBasePath}sms/salesforce/capture-link`, payload);
  }

  captureByEmail(payload: ISendLinkPayload): Observable<ISendLinkResponse> {
    return this.http.post<ISendLinkResponse>(`${this.paymentBasePath}email/capture-link`, payload);
  }

  captureManually(payload: ISendLinkPayload): Observable<ISendLinkResponse> {
    return this.http.post<ISendLinkResponse>(`${this.paymentBasePath}agent/capture-link`, payload);
  }

}
